import * as React from 'react';
import { ReactComponent as EyeRegularIconSVG } from '../../assets/icons/mevo/ic_eye_regular.svg';
import IconPattern, { IconProps } from './_IconPattern';

const EyeRegularIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={EyeRegularIconSVG} variantPlaces={2} {...props} />;
};

export default EyeRegularIcon;
